import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const ProjectGrid = ({ projects }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
      {projects.map((project, index) => (
        <motion.div
          key={project.id}
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: index * 0.1 }}
          className="group"
        >
          <Link to={`/project/${project.id}`}>
            <div className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 group-hover:transform group-hover:scale-105 h-full flex flex-col">
              {/* Project Image - Fixed Height Container */}
              <div className="bg-quaternary overflow-hidden h-64 flex-shrink-0">
                <img
                  src={project['Project Image 1']}
                  alt={project['Project Name']}
                  className="w-full h-full object-cover group-hover:opacity-90 transition-opacity duration-300"
                  onError={(e) => {
                    e.target.src = 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=600&fit=crop';
                  }}
                />
              </div>
              
              {/* Project Info - Flexible Height */}
              <div className="p-6 flex-grow flex flex-col">
                <h3 className="font-blanka text-xl font-bold text-primary mb-3 group-hover:text-accent-primary transition-colors duration-300">
                  {project['Project Name']}
                </h3>
                
                {project['Project Overview'] && (
                  <p className="font-barlow text-tertiary mb-4 line-clamp-3 flex-grow">
                    {project['Project Overview']}
                  </p>
                )}
                
                {project['Location'] && (
                  <p className="font-poppins text-sm text-quaternary mb-4">
                    {project['Location']}
                  </p>
                )}
                
                <div className="mt-auto inline-flex items-center text-accent-primary font-barlow font-medium group-hover:text-accent-secondary transition-colors duration-300">
                  View Project →
                </div>
              </div>
            </div>
          </Link>
        </motion.div>
      ))}
    </div>
  );
};

export default ProjectGrid;